import React from 'react'
import { StyleSheet } from 'react-native'
import { Svg } from 'react-native-svg'
import { VictoryAnimation, VictoryLabel, VictoryPie } from 'victory'

import { Color, Font } from '../../style'

const styles = StyleSheet.create({
  pie: {
    flex: 1,
  },
  label: {
    fontFamily: Font.regular,
    fontSize: 64,
  },
})

export interface Props {
  value?: number
  width?: number
  height?: number
  animationDuration?: number
}
const ChartPie = (props: Props) => {
  const { value = 1, width, height, animationDuration = 1000 } = props

  const getData = (value: number) => {
    return [
      { x: 1, y: (1 - value) * 100 },
      { x: 2, y: value * 100 },
    ]
  }

  const labelStyle = [styles.label, { fill: Color.premiumBlack }]

  return (
    <Svg style={styles.pie} viewBox="0 0 400 400" width={width} height={height}>
      <VictoryPie
        standalone={false}
        animate={{ duration: animationDuration }}
        data={getData(value)}
        innerRadius={200}
        cornerRadius={25}
        labels={() => null}
        style={{
          data: {
            fill: ({ datum }) => (datum.x === 2 ? Color.greyBlue : 'transparent'),
          },
        }}
      />
      <VictoryAnimation duration={animationDuration} data={{ value }}>
        {({ value }) => {
          return (
            <VictoryLabel
              textAnchor="middle"
              verticalAnchor="middle"
              x={200}
              y={200}
              text={`${Math.round((value as number) * 100)} %`}
              style={labelStyle}
            />
          )
        }}
      </VictoryAnimation>
    </Svg>
  )
}

export default ChartPie
